import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { StudyBuildPart } from './study-build-part';

export class KitInventoryBuildPart extends BaseBuildPart {
    constructor(private readonly studyHelperParams: HelperParams,
                parent: StudyBuildPart,
                siteId: number) {
        super(studyHelperParams, parent, siteId ? ['kit-inventory', siteId] : ['kit-inventory']);
    }

    public inventorySummary(): BaseBuildPart {
        return new BaseBuildPart(this.studyHelperParams, this, ['inventory-summary']);
    }

    public expiration(): BaseBuildPart {
        return new BaseBuildPart(this.studyHelperParams, this, ['on-hand-expiration']);
    }
}